import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayRoleModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/roles/models/output/gateway-role.model';
import { CellContext } from '@tanstack/react-table';

export interface RoleListNameCellProps
  extends CellContext<GatewayRoleModel, GatewayRoleModel['name']> {}

export const RoleListNameCell = (
  props: RoleListNameCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return <Text truncate>{getValue()}</Text>;
};
